module.exports = __webpack_public_path__ + "img/Picture3.acef5c4b.png";